
import { defineComponent } from 'vue'
import FilePopItem from '@remote/components/FilePopItem.vue'
import { useBTResult } from '@remote/store/hezi-file/bt-result'
import Loading from '@remote/components/Loading.vue'
import { syncInspecBTTask } from '@remote/api/adapter/interceptors/request/get-resource-list'
import { checkState } from '@remote/store/utils'

export default defineComponent({
  components: {
    FilePopItem,
    Loading,
  },
  setup () {
    return {
      store: useBTResult(),
    }
  },
  computed: {
    visible () {
      return !!this.store.data.visible
    },
    files () {
      return this.store.data.files
    },
    name () {
      return this.store.data.name
    },
    totalDownloaded () {
      return this.store.data.totalDownloaded
    },
    totalFileNums () {
      return this.store.data.totalFileNums
    },
    isLoading () {
      return !!this.store.data.isLoading
    },
    hasContinueAddTaskBtn () {
      return !!(this.store.data.url && !this.store.data.url?.includes('xdrive://hezi'))
    },
  },
  methods: {
    close () {
      this.store.toggleVisibleBTResult(false)
    },
    async loadFunction (file) {
      console.log('loadFunction', file)
      this.isLoading = true
      try {
        await this.store.dispatch('getFiles', {
          parent_id: file.id,
          name: file.name,
        })
        this.isLoading = false
      } catch (error) {
        console.log(error)
        this.isLoading = false
      }
    },
    handleOnContinueAddTask () {
      if (checkState()) return
      syncInspecBTTask(this.store.data.url, this.store.data.isCompleted)
      this.close()
    },
  },
})
